import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import type { ReactNode } from 'react'
import { useMemo } from 'react'

import { useGlobalState } from '@/hooks/useGlobalState'

interface StripeProviderProps {
  children: ReactNode
  clientSecret?: string
}

export function StripeProvider({ children, clientSecret }: StripeProviderProps) {
  const { configStore } = useGlobalState()

  // Dynamically load Stripe with the runtime-configured publishable key
  const stripePromise = useMemo(() => {
    const publishableKey = configStore.stripePublishableKey
    if (!publishableKey) {
      console.warn('Stripe publishable key not available')
      return null
    }
    return loadStripe(publishableKey)
  }, [configStore.stripePublishableKey])

  const options = {
    clientSecret,
    appearance: {
      theme: 'stripe' as const,
      variables: {
        colorPrimary: '#5c7cfa', // Match our indigo theme
        colorBackground: '#ffffff',
        colorText: '#30313d',
        colorDanger: '#df1b41',
        fontFamily: 'system-ui, sans-serif',
        spacingUnit: '4px',
        borderRadius: '8px',
      },
    },
  }

  return (
    <Elements stripe={stripePromise} options={clientSecret ? options : undefined}>
      {children}
    </Elements>
  )
}
